export const humanize = str =>
  (str === null || str === undefined ? "" : str)
    .toString()
    .replace(/^[\s_]+|[\s_]+$/g, "")
    .replace(/[_\s]+/g, " ")
    .replace(/^[a-z]/, v => v.toUpperCase());
